import { DisplaySize } from "@lhd/constants";
import { ButtonProps } from "antd";
import { ReactNode } from "react";
export type ReceivedProps = {
  label: string | ReactNode;
  loading?: boolean;
  className?: string;
  icon?: ReactNode;
  htmlType?: boolean;
  disabled?: boolean;
  danger?: boolean;
  missingRequire?: boolean;
  onClick?: () => void;
  onMouseDown?: ButtonProps["onMouseDown"];
  style?: any;
  type?: string;
  iconRight?: boolean;
  height?: number;
  displaySize?: DisplaySize;
  typeButtonHeight?: "small" | "large";
};

const useButton = (props: ReceivedProps) => {
  return {
    ...props,
  };
};

export type Props = ReturnType<typeof useButton>;

export default useButton;
